<template>
  <v-app id="app_overdue_collections">
    <v-container fluid>
      <v-overlay v-model="loading" class="align-center justify-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>

      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">NOTIFY COLLECTIONS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Review overdue collections request data and send it or approve.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-divider thickness="2"></v-divider>

        <v-expansion-panels v-model="panelOpen" multiple>
          <v-expansion-panel value="filters" elevation="0">
            <v-expansion-panel-title expand-icon="mdi-menu-down">
              <v-icon class="mr-3">mdi-filter-menu-outline</v-icon>
              <span class="text-body-1 font-weight-bold">FILTERS</span>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row class="mt-2" dense>

                <!-- Date Range -->
                <v-col cols="12" md="4" class="py-1">
                  <v-date-input
                    v-model="dates"
                    prepend-inner-icon="$calendar"
                    prepend-icon=""
                    clearable
                    label="Select Date Range"
                    multiple="range"
                    density="comfortable"
                    class="custom_input_field_color"
                    variant="outlined"
                    @click:clear="clearDateRange"
                  ></v-date-input>
                </v-col>

                <!-- Sales Rep -->
                <v-col cols="12" md="4" class="py-1">
                  <v-select
                    v-model="selectedAgent"
                    :items="agentListsWithDetails"
                    density="comfortable"
                    clearable
                    item-title="text"
                    item-value="value"
                    class="custom_input_field_color"
                    label="Sales Rep"
                    multiple
                    placeholder="Select sales representative"
                    variant="outlined"
                    :loading="salesRepsLoading"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="undefined">
                        <template v-slot:prepend>
                          <v-checkbox-btn :model-value="props.selected"></v-checkbox-btn>
                        </template>
                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                          REG NO: {{ item.raw.registration }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                        close-icon="mdi-close-circle"
                      >
                        {{ item.raw.text }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>

                <!-- Route -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedRoute"
                    :items="routeTypeOptions"
                    item-title="text"
                    item-value="value"
                    label="Route"
                    placeholder="Select route"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Dealer -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedDealer"
                    :items="dealerListsWithDetails"
                    clearable
                    density="comfortable"
                    item-title="text"
                    item-value="value"
                    label="Dealer"
                    class="custom_input_field_color"
                    multiple
                    placeholder="Select dealer"
                    variant="outlined"
                    :loading="dealersLoading"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="undefined">
                        <template v-slot:prepend>
                          <v-checkbox-btn :model-value="props.selected"></v-checkbox-btn>
                        </template>
                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                          REG NO: {{ item.raw.registration }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.raw.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Area -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectDistrict"
                    :items="areaLists"
                    item-title="text"
                    item-value="value"
                    label="Area"
                    placeholder="Select area"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    :loading="areasLoading"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Payment Status -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedStatus"
                    :items="paymentStatusOptions"
                    item-title="text"
                    item-value="value"
                    label="Payment Status"
                    placeholder="Select payment status"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Collection Type -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedCollectionType"
                    :items="collectionTypeOptions"
                    item-title="text"
                    item-value="value"
                    label="Collection Type"
                    placeholder="Select type"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Piyestra Company -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedCompany"
                    :items="hardcodedCompanyLists"
                    item-title="text"
                    item-value="value"
                    label="Piyestra Company"
                    placeholder="Select company"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="item.raw.text">
                        <v-list-item-subtitle style="font-size: 11px;">
                          {{ item.raw.fullName }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.raw.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Notify Approval Stage Filter -->
                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedApprovedStage"
                    :items="approvedStageOptions"
                    item-title="text"
                    item-value="value"
                    label="Notify Approval Stage"
                    placeholder="Select stage"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    chips
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Search -->
                <v-col cols="12" md="4" class="py-1">
                  <v-text-field
                    v-model="search"
                    clearable
                    label="Search"
                    placeholder="Search by Receipt ID, Company, Area, Sales Rep, Dealer, Payment Method, Stage, etc."
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-divider class="mb-3 mt-2"></v-divider>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Table - with compact styling -->
        <v-card-text class="table-wrapper">
          <!--
            FIX: hide-default-footer + disable-pagination
            These hide Vuetify's built-in pagination bar (the non-working one)
            and keep ONLY the custom footer below.
          -->
          <v-data-table
            :headers="headers"
            :items="notifyCollections"
            :items-per-page="-1"
            :loading="loading"
            item-value="id"
            class="px-2 custom_table_curved compact-table"
            @update:options="onTableOptionsChange"
            :server-items-length="paginationInfo ? paginationInfo.total : 0"
            fixed-header
            height="calc(100vh - 260px)"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>

            <!-- Receipt No -->
            <template v-slot:[`item.receipt_no`]="{ item }">
              <p class="font-weight-bold text-body-2 mt-1" style="color: #424242;">{{ item.receipt_id }}</p>
            </template>

            <!-- Manual Receipt Number -->
            <template v-slot:[`item.manual_receipt_number`]="{ item }">
              <div>
                <v-chip color="#01579B" variant="flat" size="small" class="font-weight-medium">
                  {{ item.manual_receipt_number || 'N/A' }}
                </v-chip>
              </div>
            </template>

            <!-- Date with Time -->
            <template v-slot:[`item.collection_date`]="{ item }">
              <div class="column-content font-weight-medium" style="color: #616161;">
                <div>{{ formatDateForExcel(item.created_at) }}</div>
                <div style="font-size: 10px; color: #888;">{{ formatTimeForExcel(item.created_at) }}</div>
              </div>
            </template>

            <!-- Notify Date with Time -->
            <template v-slot:[`item.notify_date`]="{ item }">
              <div v-if="item.notify === true && item.updated_at" class="column-content" style="color: #616161;">
                <div>{{ formatDateForExcel(item.updated_at) }}</div>
                <div style="font-size: 10px; color: #888;">{{ formatTimeForExcel(item.updated_at) }}</div>
              </div>
              <div v-else-if="item.notify === true && !item.updated_at" class="column-content" style="color: #616161;">
                <div>{{ formatDateForExcel(item.created_at) }}</div>
                <div style="font-size: 10px; color: #888;">{{ formatTimeForExcel(item.created_at) }}</div>
              </div>
              <p v-else class="text-body-2 text-grey mt-1">Not Notified</p>
            </template>

            <!-- Area Code -->
            <template v-slot:[`item.area_code`]="{ item }">
              <p class="text-body-2 mt-1">{{ item.area_code || '-' }}</p>
            </template>

            <!-- Company Name -->
            <template v-slot:[`item.company_name`]="{ item }">
              <p class="text-body-2 mt-1" :title="item.ar_company || ''">{{ getShortCompanyName(item.ar_company) || '-' }}</p>
            </template>

            <!-- Sales Ex. Code -->
            <template v-slot:[`item.sales_ex_code`]="{ item }">
              <p class="text-body-2 mt-1">{{ getSalesExecutiveCode(item) || '-' }}</p>
            </template>

            <!-- Sales Executive Name -->
            <template v-slot:[`item.sales_ex_name`]="{ item }">
              <p class="text-body-2 mt-1">{{ getSalesExecutiveName(item) || '-' }}</p>
            </template>

            <!-- Customer No -->
            <template v-slot:[`item.customer_no`]="{ item }">
              <p class="text-body-2 mt-1">{{ item.dealer_code || '-' }}</p>
            </template>

            <!-- Customer Name -->
            <template v-slot:[`item.customer_name`]="{ item }">
              <div v-if="item.dealer_name">
                <p class="font-weight-bold text-body-2 mt-1">{{ item.dealer_name }}</p>
              </div>
              <div v-else>
                <p class="text-body-2 mt-1 text-grey">-</p>
              </div>
            </template>

            <!-- Customer Dis.Group -->
            <template v-slot:[`item.discount_group`]="{ item }">
              <p class="text-body-2 mt-1">{{ getDiscountGroup(item) }}</p>
            </template>

            <!-- Invoice No -->
            <template v-slot:[`item.invoice_no`]="{ item }">
              <div v-if="item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p class="text-body-2">{{ invItem.document_no || '-' }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Invoice Date -->
            <template v-slot:[`item.invoice_date`]="{ item }">
              <div v-if="item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p class="text-body-2">{{ formatDateForExcel(invItem.posting_date) }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Invoice Amount -->
            <template v-slot:[`item.invoice_amount`]="{ item }">
              <div v-if="item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p style="color: #01579B; font-size: 12px;" class="font-weight-medium">LKR {{ formatNumber(invItem.amount) }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Collection Amount -->
            <template v-slot:[`item.collection_amount`]="{ item }">
              <p style="color: #01579B; font-size: 13px;" class="font-weight-black mt-1">LKR {{ formatNumber(item.collect_total_amount) }}</p>
            </template>

            <!-- Payment Method -->
            <template v-slot:[`item.payment_method`]="{ item }">
              <v-chip
                :color="item.payment_method === 'CASH' ? 'green-darken-2' : (item.payment_method === 'CHEQUE' ? 'blue-darken-2' : 'orange-darken-2')"
                size="x-small"
                variant="elevated"
                class="font-weight-bold justify-center"
                style="width: fit-content;"
              >
                <v-icon start size="x-small">{{ item.payment_method === 'CASH' ? 'mdi-cash' : (item.payment_method === 'CHEQUE' ? 'mdi-bank-outline' : 'mdi-bank-transfer') }}</v-icon>
                {{ item.payment_method || '-' }}
              </v-chip>
            </template>

            <!-- Payment Status -->
            <template v-slot:[`item.payment_status`]="{ item }">
              <v-chip
                :color="getPaymentStatusColor(item.payment_status)"
                size="x-small"
                variant="flat"
                class="font-weight-bold"
              >
                {{ item.payment_status || '-' }}
              </v-chip>
            </template>

            <!-- Receipt Status -->
            <template v-slot:[`item.receipt_status`]="{ item }">
              <v-chip
                :color="getReceiptStatusColor(item.receipt_status)"
                size="x-small"
                variant="flat"
                class="font-weight-bold"
              >
                {{ item.receipt_status || '-' }}
              </v-chip>
            </template>

            <!-- Overdue Days -->
            <template v-slot:[`item.overdue_days`]="{ item }">
              <v-chip
                :color="(item.overdue_count || 0) >= 30 ? 'error' : (item.overdue_count || 0) >= 5 ? 'warning' : 'info'"
                size="x-small"
                variant="flat"
                class="font-weight-bold"
              >
                {{ getOverdueDisplayText(item) }}
              </v-chip>
            </template>

            <!-- Overdue Reason -->
            <template v-slot:[`item.overdue_reason`]="{ item }">
              <p class="text-body-2 mt-1 text-truncate" style="max-width: 180px;" :title="item.overdue_reason || 'None'">
                {{ item.overdue_reason && item.overdue_reason !== '-' ? item.overdue_reason : '-' }}
              </p>
            </template>

            <!-- Cheque Date -->
            <template v-slot:[`item.cheque_date`]="{ item }">
              <div v-if="item.payment_method === 'CHEQUE' && item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p class="text-body-2">{{ invItem.cheque_date ? formatDateForExcel(invItem.cheque_date) : '-' }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Cheque No -->
            <template v-slot:[`item.cheque_no`]="{ item }">
              <div v-if="item.payment_method === 'CHEQUE' && item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p class="text-body-2">{{ invItem.cheque_number || '-' }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Bank Name -->
            <template v-slot:[`item.bank_name`]="{ item }">
              <div v-if="item.payment_method === 'CHEQUE' && item.items && item.items.length > 0">
                <div v-for="(invItem, idx) in item.items" :key="idx" class="mb-0">
                  <p class="text-body-2">{{ invItem.bank_name || '-' }}</p>
                </div>
              </div>
              <p v-else class="text-body-2 text-grey">-</p>
            </template>

            <!-- Notify Approval Status -->
            <template v-slot:[`item.pending_at`]="{ item }">
              <div>
                <v-chip
                  :color="getNotifyStatusColor(item)"
                  size="x-small"
                  variant="flat"
                  class="font-weight-bold mb-1"
                >
                  {{ getNotifyStatusLabel(item) }}
                </v-chip>
              </div>
            </template>

            <!-- Action -->
            <template v-slot:[`item.action`]="{ item }">
              <div class="d-flex flex-column align-start gap-1 py-1">

                <v-btn
                  class="custom_view_btn mb-1"
                  variant="flat"
                  size="x-small"
                  style="min-width: 110px; justify-content: flex-start;"
                  @click="viewItem(item)"
                >
                  <v-icon size="x-small" class="mr-1">mdi-eye</v-icon>
                  VIEW
                </v-btn>

                <v-btn
                  v-if="item.notify === true && getNotifyApprovalStatus(item) === 'APPROVED'"
                  class="custom_details_btn mb-1"
                  variant="flat"
                  size="x-small"
                  style="min-width: 110px; justify-content: flex-start;"
                  @click="openNotifyDetailsDialog(item)"
                >
                  <v-icon size="x-small" class="mr-1">mdi-dots-horizontal</v-icon>
                  DETAILS
                </v-btn>

                <v-btn
                  v-if="item.notify !== true"
                  class="custom_notify_btn mb-1"
                  variant="flat"
                  size="x-small"
                  style="min-width: 110px; justify-content: flex-start;"
                  @click="notifyItem(item)"
                  :loading="notifyingItems.includes(item.id)"
                >
                  NOTIFY
                  <v-icon class="ml-1" size="x-small">mdi-bell</v-icon>
                </v-btn>

                <v-btn
                  v-if="item.notify === true && getNotifyApprovalStatus(item) === 'PENDING'"
                  class="custom_approve_btn mb-1"
                  variant="flat"
                  size="x-small"
                  style="min-width: 110px; justify-content: flex-start;"
                  @click="openApproveDialog(item)"
                  :loading="approvingItems.includes(item.id)"
                >
                  <v-icon size="x-small" class="mr-1">mdi-check-circle</v-icon>
                  APPROVE
                </v-btn>

              </div>
            </template>
            
          </v-data-table>
        </v-card-text>

        <!-- Custom Pagination Footer (THE ONE THAT WORKS) -->
        <v-card-text class="pt-0">
          <div class="d-flex align-center justify-space-between pa-2">
            <div class="text-caption text-grey-darken-1">
              Showing {{ paginationInfo ? paginationInfo.from || 0 : 0 }} to {{ paginationInfo ? paginationInfo.to || 0 : 0 }} of {{ paginationInfo ? paginationInfo.total || 0 : 0 }} entries
            </div>
            <div class="d-flex align-center">
              <v-btn
                class="mr-1"
                size="small"
                variant="text"
                :disabled="currentPage <= 1 || loading"
                @click="goToPage(currentPage - 1)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              
              <v-btn
                v-for="page in visiblePages"
                :key="page"
                size="small"
                variant="text"
                :color="page === currentPage ? 'primary' : ''"
                :disabled="loading"
                @click="goToPage(page)"
                style="min-width: 32px;"
              >
                {{ page }}
              </v-btn>
              
              <v-btn
                class="ml-1"
                size="small"
                variant="text"
                :disabled="currentPage >= (paginationInfo ? paginationInfo.last_page : 1) || loading"
                @click="goToPage(currentPage + 1)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <!-- Export buttons at the bottom -->
        <v-divider thickness="1"></v-divider>
        <v-card-text class="custom_tool_bar_style d-flex justify-end py-2">
          <v-btn class="custom_pdf_btn" variant="outlined" @click="exportPDF" :loading="exporting" size="small">
            <v-icon size="small">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel" :loading="exporting" size="small">
            <v-icon size="small">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

      </v-card>

      <!-- APPROVE DIALOG -->
      <v-dialog v-model="approveDialog" max-width="500" persistent>
        <v-card rounded="lg" elevation="4">
          <v-card-title class="d-flex align-center pa-4" style="background: #E8F5E9; border-bottom: 2px solid #C8E6C9;">
            <v-icon color="success" size="28" class="mr-3">mdi-check-circle-outline</v-icon>
            <div>
              <p class="text-body-1 font-weight-bold mb-0" style="color: #1B5E20;">APPROVE NOTIFY COLLECTION</p>
              <p class="text-caption mb-0" style="color: #388E3C;">
                Receipt: <strong>{{ approveTarget ? approveTarget.receipt_id : '' }}</strong>
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon variant="text" size="small" @click="closeApproveDialog" :disabled="approveLoading">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-5">
            <v-card v-if="approveTarget" variant="tonal" color="blue-grey" class="mb-4 pa-3" rounded="lg">
              <v-row dense>
                <v-col cols="6">
                  <p class="text-caption text-grey-darken-1 mb-0">Customer</p>
                  <p class="text-body-2 font-weight-bold mb-0">{{ approveTarget.dealer_name || '-' }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="text-caption text-grey-darken-1 mb-0">Amount</p>
                  <p class="text-body-2 font-weight-bold mb-0" style="color: #01579B;">
                    LKR {{ formatNumber(approveTarget.collect_total_amount) }}
                  </p>
                </v-col>
                <v-col cols="6" class="mt-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Payment Method</p>
                  <p class="text-body-2 font-weight-medium mb-0">{{ approveTarget.payment_method || '-' }}</p>
                </v-col>
                <v-col cols="6" class="mt-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Sales Rep</p>
                  <p class="text-body-2 font-weight-medium mb-0">{{ getSalesRepName(approveTarget.saleRep_id) || '-' }}</p>
                </v-col>
              </v-row>
            </v-card>

            <v-textarea
              v-model="approveComment"
              label="Approval Comment (Optional)"
              placeholder="Enter any remarks or notes about this approval..."
              variant="outlined"
              density="comfortable"
              rows="3"
              class="custom_input_field_color"
              counter="1000"
              maxlength="1000"
              :disabled="approveLoading"
            ></v-textarea>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4 d-flex justify-end gap-3">
            <v-btn variant="outlined" color="grey" @click="closeApproveDialog" :disabled="approveLoading" style="min-width: 100px;">
              CANCEL
            </v-btn>
            <v-btn variant="flat" color="success" @click="submitApprove" :loading="approveLoading" style="min-width: 120px;">
              <v-icon size="small" class="mr-1">mdi-check</v-icon>
              CONFIRM APPROVE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- NOTIFY DETAILS DIALOG -->
      <v-dialog v-model="notifyDetailsDialog" max-width="600" persistent>
        <v-card rounded="lg" elevation="4">
          <v-card-title class="d-flex align-center pa-4" style="background: #E8F5E9; border-bottom: 2px solid #C8E6C9;">
            <v-icon color="success" size="28" class="mr-3">mdi-information-outline</v-icon>
            <div>
              <p class="text-body-1 font-weight-bold mb-0" style="color: #1B5E20;">NOTIFICATION DETAILS</p>
              <p class="text-caption mb-0" style="color: #388E3C;">
                Receipt: <strong>{{ notifyDetailsTarget ? notifyDetailsTarget.receipt_id : '' }}</strong>
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon variant="text" size="small" @click="closeNotifyDetailsDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-5" v-if="notifyDetailsTarget">
            <v-alert type="success" variant="tonal" class="mb-4" rounded="lg">
              <div class="d-flex align-center">
                <div>
                  <div class="text-subtitle-1 font-weight-bold">Approved</div>
                  <div class="text-caption">This notification has been approved</div>
                </div>
              </div>
            </v-alert>

            <v-card variant="outlined" class="mb-4 pa-3" rounded="lg" color="success">
              <v-row dense>
                <v-col cols="12" class="py-1">
                  <div class="d-flex align-center">
                    <v-icon size="16" color="success" class="mr-2">mdi-account-check</v-icon>
                    <span class="text-caption text-grey-darken-1">Approved By:</span>
                    <span class="text-body-2 font-weight-bold ml-2">
                      {{ notifyDetailsTarget.notify_approval_details?.notify_approved_by?.name || '-' }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" class="py-1">
                  <div class="d-flex align-center">
                    <v-icon size="16" color="primary" class="mr-2">mdi-calendar-clock</v-icon>
                    <span class="text-caption text-grey-darken-1">Approved At:</span>
                    <span class="text-body-2 font-weight-medium ml-2">
                      {{ formatDateForExcel(notifyDetailsTarget.notify_approval_details?.notify_approved_at) }}
                      {{ formatTimeForExcel(notifyDetailsTarget.notify_approval_details?.notify_approved_at) }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" class="py-1" v-if="notifyDetailsTarget.notify_approval_details?.notify_approved_comment">
                  <div class="d-flex align-start">
                    <v-icon size="16" color="grey-darken-1" class="mr-2">mdi-comment-text-outline</v-icon>
                    <div>
                      <span class="text-caption text-grey-darken-1">Comment:</span>
                      <v-card variant="tonal" color="grey-lighten-2" class="pa-2 mt-1" rounded="sm">
                        <p class="text-body-2 mb-0" style="white-space: pre-wrap; word-break: break-word;">
                          {{ notifyDetailsTarget.notify_approval_details.notify_approved_comment }}
                        </p>
                      </v-card>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>

            <v-card variant="tonal" color="blue-grey" class="mb-3 pa-3" rounded="lg">
              <p class="text-subtitle-2 font-weight-bold mb-2" style="color: #01579B;">
                Collection Details
              </p>
              <v-row dense>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Customer</p>
                  <p class="text-body-2 font-weight-bold mb-0">{{ notifyDetailsTarget.dealer_name || '-' }}</p>
                </v-col>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Amount</p>
                  <p class="text-body-2 font-weight-bold mb-0" style="color: #01579B;">
                    LKR {{ formatNumber(notifyDetailsTarget.collect_total_amount) }}
                  </p>
                </v-col>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Payment Method</p>
                  <p class="text-body-2 font-weight-medium mb-0">{{ notifyDetailsTarget.payment_method || '-' }}</p>
                </v-col>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Sales Rep</p>
                  <p class="text-body-2 font-weight-medium mb-0">{{ getSalesRepName(notifyDetailsTarget.saleRep_id) || '-' }}</p>
                </v-col>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Area Code</p>
                  <p class="text-body-2 font-weight-medium mb-0">{{ notifyDetailsTarget.area_code || '-' }}</p>
                </v-col>
                <v-col cols="6" class="py-1">
                  <p class="text-caption text-grey-darken-1 mb-0">Company</p>
                  <p class="text-body-2 font-weight-medium mb-0" :title="notifyDetailsTarget.ar_company || ''">{{ getShortCompanyName(notifyDetailsTarget.ar_company) || '-' }}</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card v-if="notifyDetailsTarget.items && notifyDetailsTarget.items.length > 0" variant="outlined" class="pa-3" rounded="lg">
              <p class="text-subtitle-2 font-weight-bold mb-2" style="color: #01579B;">
                Invoice Details
              </p>
              <v-table density="compact" class="custom_table_curved">
                <thead>
                  <tr>
                    <th class="text-caption">Invoice No</th>
                    <th class="text-caption">Invoice Date</th>
                    <th class="text-caption">Amount</th>
                    <th class="text-caption">Sales Ex. Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inv, idx) in notifyDetailsTarget.items" :key="idx">
                    <td class="text-body-2">{{ inv.document_no || '-' }}</td>
                    <td class="text-body-2">{{ formatDateForExcel(inv.posting_date) }}</td>
                    <td class="text-body-2 text-right" style="color: #01579B; font-weight: 500;">
                      LKR {{ formatNumber(inv.amount) }}
                    </td>
                    <td class="text-body-2">{{ inv.salesperson_code || '-' }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4 d-flex justify-end">
            <v-btn variant="flat" color="primary" @click="closeNotifyDetailsDialog" style="min-width: 100px;">
              CLOSE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :timeout="5000" :color="snackbarColor" location="top right">
        <span class="font-weight-medium">{{ snackbarText }}</span>
        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import { EventBus } from "@/plugins/event-bus";
import { mapActions } from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { getPermissions } from "@/plugins/permissions";
import _ from 'lodash';

const BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  name: 'CollectionNotify',

  data() {
    return {
      panelOpen: [],
      dates: [],
      search: '',
      selectedReceiptIds: [],

      isRestoring: false,
      skipNextSearchWatch: false,

      selectedAgent: [],
      selectedRoute: [],
      selectedDealer: [],
      selectDistrict: [],
      selectedStatus: [],
      selectedCollectionType: [],
      selectedCompany: [],
      selectedApprovedStage: [],

      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      loading: false,
      exporting: false,
      salesRepsLoading: false,
      dealersLoading: false,
      areasLoading: false,
      notifyingItems: [],

      approveDialog: false,
      approveTarget: null,
      approveComment: '',
      approveLoading: false,
      approvingItems: [],

      notifyDetailsDialog: false,
      notifyDetailsTarget: null,

      agentListsWithDetails: [],
      dealerListsWithDetails: [],
      areaLists: [],

      approvedStageOptions: [
        { text: 'PENDING',  value: 'PENDING',  title: 'PENDING'  },
        { text: 'APPROVED', value: 'APPROVED', title: 'APPROVED' },
      ],

      routeTypeOptions: [
        { text: 'Assign Route Plan', value: 'Assign Route Plan' },
        { text: 'Direct',            value: 'Direct'            },
        { text: 'Own Route Plan',    value: 'Own Route Plan'    },
      ],

      companyShortNames: {
        'Piyestra Furniture (Pvt) Ltd':  'PIY',
        'D.R.Industries (Pvt) Ltd':      'DRI',
        'D.R.Home Appliances (Pvt) Ltd': 'DRH',
      },

      hardcodedCompanyLists: [
        { text: 'PIY', value: 'Piyestra Furniture (Pvt) Ltd',  title: 'PIY', fullName: 'Piyestra Furniture (Pvt) Ltd'  },
        { text: 'DRI', value: 'D.R.Industries (Pvt) Ltd',      title: 'DRI', fullName: 'D.R.Industries (Pvt) Ltd'      },
        { text: 'DRH', value: 'D.R.Home Appliances (Pvt) Ltd', title: 'DRH', fullName: 'D.R.Home Appliances (Pvt) Ltd' },
      ],

      paymentStatusOptions: [
        { text: 'OVERDUE', value: 'OVERDUE', title: 'OVERDUE' },
        { text: 'UNPAID',  value: 'UNPAID',  title: 'UNPAID'  },
        { text: 'ADVANCE', value: 'ADVANCE', title: 'ADVANCE' },
      ],

      collectionTypeOptions: [
        { text: 'CASH',   value: 'CASH',   title: 'CASH'   },
        { text: 'BANK',   value: 'BANK',   title: 'BANK'   },
        { text: 'CHEQUE', value: 'CHEQUE', title: 'CHEQUE' },
      ],

      notifyCollections: [],
      paginationInfo: null,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,

      headers: [
        { title: 'RECEIPT NO',             value: 'receipt_no',        sortable: true  },
        { title: 'MANUAL RECEIPT NO',      value: 'manual_receipt_number', sortable: false },
        { title: 'DATE',                   value: 'collection_date',   sortable: true  },
        { title: 'NOTIFY DATE',            value: 'notify_date',       sortable: true  },
        { title: 'AREA CODE',              value: 'area_code',         sortable: true  },
        { title: 'COMPANY NAME',           value: 'company_name',      sortable: true  },
        { title: 'SALES EX. CODE',         value: 'sales_ex_code',     sortable: true  },
        { title: 'SALES EXECUTIVE NAME',   value: 'sales_ex_name',     sortable: true  },
        { title: 'CUSTOMER NO',            value: 'customer_no',       sortable: true  },
        { title: 'CUSTOMER NAME',          value: 'customer_name',     sortable: true  },
        { title: 'CUSTOMER DIS.GROUP',     value: 'discount_group',    sortable: false },
        { title: 'INVOICE NO',             value: 'invoice_no',        sortable: false },
        { title: 'INVOICE DATE',           value: 'invoice_date',      sortable: false },
        { title: 'INVOICE AMOUNT',         value: 'invoice_amount',    sortable: true  },
        { title: 'COLLECTION AMOUNT (LKR)',value: 'collection_amount', sortable: true  },
        { title: 'PAYMENT METHOD',         value: 'payment_method',    sortable: false },
        { title: 'PAYMENT STATUS',         value: 'payment_status',    sortable: true  },
        { title: 'RECEIPT STATUS',         value: 'receipt_status',    sortable: true  },
        { title: 'OVERDUE REASON',         value: 'overdue_reason',    sortable: false },
        { title: 'CHEQUE DATE',            value: 'cheque_date',       sortable: true  },
        { title: 'CHEQUE NO',              value: 'cheque_no',         sortable: false },
        { title: 'BANK NAME',              value: 'bank_name',         sortable: false },
        { title: 'NOTIFY STATUS',          value: 'pending_at',        sortable: true  },
        { title: 'ACTION',                 value: 'action',            sortable: false, align: 'center' },
      ],

      permissions: { read: false, write: false, delete: false },
      salesRepMap: {},
    };
  },

  computed: {
    visiblePages() {
      if (!this.paginationInfo) return [1];
      const current = this.currentPage;
      const last = this.paginationInfo.last_page || 1;
      const pages = [];
      const maxVisible = 5;
      
      if (last <= maxVisible) {
        for (let i = 1; i <= last; i++) pages.push(i);
      } else {
        let start = Math.max(1, current - 2);
        let end = Math.min(last, current + 2);
        
        if (start === 1) end = Math.min(last, maxVisible);
        else if (end === last) start = Math.max(1, last - maxVisible + 1);
        
        for (let i = start; i <= end; i++) pages.push(i);
        
        if (start > 1) {
          pages.unshift('...');
          pages.unshift(1);
        }
        if (end < last) {
          pages.push('...');
          pages.push(last);
        }
      }
      return pages;
    }
  },

  methods: {
    ...mapActions(['updateSharedDataOverdueCollection']),

    getDateRange() {
      let list = [];
      if (Array.isArray(this.dates)) list = this.dates;
      else if (this.dates) list = [this.dates];

      const valid = list
        .map(d => (d instanceof Date ? d : new Date(d)))
        .filter(d => d && !isNaN(d.getTime()))
        .sort((a, b) => a.getTime() - b.getTime());

      if (valid.length === 0) return null;

      const from = this.formatDateForAPI(valid[0]);
      const to = this.formatDateForAPI(valid[valid.length - 1]);

      if (!from || !to) return null;
      return { from, to };
    },

    _saveFiltersToSession() {
      if (this.isRestoring) return;

      const filters = {
        dates: this.dates,
        search: this.search,
        selectedReceiptIds: this.selectedReceiptIds,
        selectedAgent: this.selectedAgent,
        selectedRoute: this.selectedRoute,
        selectedDealer: this.selectedDealer,
        selectDistrict: this.selectDistrict,
        selectedStatus: this.selectedStatus,
        selectedCollectionType: this.selectedCollectionType,
        selectedCompany: this.selectedCompany,
        selectedApprovedStage: this.selectedApprovedStage,
        currentPage: this.currentPage,
        perPage: this.perPage,
        panelOpen: this.panelOpen,
      };
      sessionStorage.setItem('notifyCollectionsFilters', JSON.stringify(filters));
    },

    _restoreFiltersFromSession() {
      const saved = sessionStorage.getItem('notifyCollectionsFilters');
      if (!saved) return false;
      try {
        const filters = JSON.parse(saved);

        if (filters.dates && Array.isArray(filters.dates)) {
          this.dates = filters.dates
            .map(d => new Date(d))
            .filter(d => !isNaN(d.getTime()));
        }

        if (filters.search !== undefined) {
          if (filters.search !== this.search) this.skipNextSearchWatch = true;
          this.search = filters.search;
        }
        if (filters.selectedReceiptIds) this.selectedReceiptIds = filters.selectedReceiptIds;
        if (filters.selectedAgent) this.selectedAgent = filters.selectedAgent;
        if (filters.selectedRoute) this.selectedRoute = filters.selectedRoute;
        if (filters.selectedDealer) this.selectedDealer = filters.selectedDealer;
        if (filters.selectDistrict) this.selectDistrict = filters.selectDistrict;
        if (filters.selectedStatus) this.selectedStatus = filters.selectedStatus;
        if (filters.selectedCollectionType) this.selectedCollectionType = filters.selectedCollectionType;
        if (filters.selectedCompany) this.selectedCompany = filters.selectedCompany;
        if (filters.selectedApprovedStage) this.selectedApprovedStage = filters.selectedApprovedStage;
        if (filters.currentPage) this.currentPage = filters.currentPage;
        if (filters.perPage) this.perPage = filters.perPage;
        if (filters.panelOpen) this.panelOpen = filters.panelOpen;
        return true;
      } catch (e) {
        console.warn('Failed to restore filters', e);
        return false;
      }
    },

    getShortCompanyName(fullName) {
      if (!fullName) return null;
      return this.companyShortNames[fullName] || fullName;
    },

    getReceiptStatusColor(status) {
      if (!status) return 'grey';
      const statusUpper = status.toUpperCase();
      if (statusUpper === 'COLLECTED') return 'success';
      if (statusUpper === 'REVERSED') return 'error';
      if (statusUpper === 'REQUEST REVERSAL') return 'warning';
      if (statusUpper === 'PENDING') return 'warning';
      return 'info';
    },

    getSalesExecutiveCode(item) {
      if (!item) return null;
      if (item.items && item.items.length > 0) {
        const firstItem = item.items[0];
        if (firstItem.salesperson_code) return firstItem.salesperson_code;
      }
      return item.saleRep_userCode || null;
    },

    getSalesExecutiveName(item) {
      if (!item) return null;
      if (item.saleRep_id) {
        const name = this.salesRepMap[item.saleRep_id];
        if (name) return name;
      }
      return null;
    },

    getNotifyApprovalStatus(item) {
      if (item.notify_approval_details && item.notify_approval_details.notify_approval_status) {
        return item.notify_approval_details.notify_approval_status;
      }
      if (item.notify === true) return 'PENDING';
      return null;
    },

    getNotifyStatusLabel(item) {
      if (!item.notify) return 'NOT NOTIFIED';
      const status = this.getNotifyApprovalStatus(item);
      if (status === 'APPROVED') return 'APPROVED';
      if (status === 'PENDING')  return 'PENDING';
      return 'PENDING';
    },

    getNotifyStatusColor(item) {
      if (!item.notify) return 'grey';
      const status = this.getNotifyApprovalStatus(item);
      if (status === 'APPROVED') return 'success';
      if (status === 'PENDING')  return 'warning';
      return 'warning';
    },

    getPaymentStatusColor(status) {
      if (!status) return 'grey';
      const statusUpper = status.toUpperCase();
      if (statusUpper === 'OVERDUE') return 'error';
      if (statusUpper === 'UNPAID') return 'warning';
      if (statusUpper === 'ADVANCE') return 'success';
      if (statusUpper === 'PAID') return 'success';
      return 'info';
    },

    openApproveDialog(item) {
      this.approveTarget  = item;
      this.approveComment = '';
      this.approveDialog  = true;
    },

    closeApproveDialog() {
      if (this.approveLoading) return;
      this.approveDialog  = false;
      this.approveTarget  = null;
      this.approveComment = '';
    },

    async submitApprove() {
      if (!this.approveTarget) return;

      const item = this.approveTarget;
      if (this.approvingItems.includes(item.id)) return;
      this.approvingItems.push(item.id);
      this.approveLoading = true;

      try {
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        const response = await axios.post(
          `${BASE_URL}/api/receipt/${item.id}/notify-approve`,
          {
            userId:  parseInt(userId),
            comment: this.approveComment.trim() || null,
          },
          {
            headers: {
              Authorization:  `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.data && response.data.success === true) {
          const collectionIndex = this.notifyCollections.findIndex(c => c.id === item.id);
          if (collectionIndex !== -1) {
            const approved = response.data.data;
            this.notifyCollections[collectionIndex].notify_approval_details = {
              notify_approval_status:  'APPROVED',
              notify_approved_at:      approved.notify_approved_at,
              notify_approved_comment: approved.notify_approved_comment,
              notify_approved_by:      approved.notify_approved_by,
            };
          }

          this.snackbarText  = response.data.message || `Receipt ${item.receipt_id} approved successfully!`;
          this.snackbarColor = 'success';
          this.snackbar      = true;

          this.approveLoading = false;
          this.approveDialog = false;
          this.approveTarget = null;
          this.approveComment = '';

          const approveIdx = this.approvingItems.indexOf(item.id);
          if (approveIdx !== -1) this.approvingItems.splice(approveIdx, 1);

          EventBus.emit('overdueCollectionNotified', item);
        } else {
          throw new Error(response.data?.message || 'Approve failed');
        }

      } catch (error) {
        let msg = 'Error approving collection. ';
        if (error.response) {
          if (error.response.status === 400) msg += error.response.data?.message || 'Invalid request.';
          else if (error.response.status === 401) msg += 'Unauthorized. Please login again.';
          else if (error.response.status === 404) msg += 'Receipt not found.';
          else if (error.response.data?.message) msg += error.response.data.message;
          else msg += 'Server error. Please try again.';
        } else if (error.request) {
          msg += 'No response from server. Check your network.';
        } else {
          msg += error.message || 'Please try again.';
        }

        this.snackbarText  = msg;
        this.snackbarColor = 'error';
        this.snackbar      = true;
        
        this.approveLoading = false;
        const approveIdx = this.approvingItems.indexOf(item.id);
        if (approveIdx !== -1) this.approvingItems.splice(approveIdx, 1);
      }
    },

    openNotifyDetailsDialog(item) {
      this.notifyDetailsTarget = item;
      this.notifyDetailsDialog = true;
    },

    closeNotifyDetailsDialog() {
      this.notifyDetailsDialog = false;
      this.notifyDetailsTarget = null;
    },

    goToPage(page) {
      if (page === '...') return;
      if (page >= 1 && page <= (this.paginationInfo ? this.paginationInfo.last_page : 1)) {
        this.currentPage = page;
        this.fetchNotifyCollections(page);
        this._saveFiltersToSession();
      }
    },

    onTableOptionsChange() {
      // no-op
    },

    getOverdueDisplayText(item) {
      if (!item) return '-';
      const overdueCount = item.overdue_count;
      if (overdueCount === null || overdueCount === undefined) return '-';
      if (overdueCount === 1) return '1 Day Overdue';
      return `${overdueCount} Days Overdue`;
    },

    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('en-GB', {
        year: 'numeric', month: 'short', day: '2-digit',
      });
    },

    formatDateForExcel(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('en-GB', {
        year: 'numeric', month: '2-digit', day: '2-digit',
      });
    },

    formatTimeForExcel(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleTimeString('en-GB', {
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      });
    },

    formatDateTime(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleString('en-GB', {
        year: 'numeric', month: 'short', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
      });
    },

    formatDateForAPI(dateString) {
      if (!dateString) return null;
      const d = dateString instanceof Date ? dateString : new Date(dateString);
      if (isNaN(d.getTime())) return null;
      const y  = d.getFullYear();
      const m  = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${dd}`;
    },

    clearDateRange() {
      this.dates = [];
    },

    backPageRoute() {
      this._saveFiltersToSession();
      
      // Try to go back to previous page using browser history
      // If there's no history (e.g., user opened link directly), fall back to dashboard
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/dashboard');
      }
    },

    getSalesRepName(saleRepId) {
      return this.salesRepMap[saleRepId] || `ID: ${saleRepId}`;
    },

    getDiscountGroup(item) {
      if (!item.items || item.items.length === 0) return '-';
      const dg = item.items[0].discount_posting_group;
      if (dg === null || dg === undefined || dg === '') return '-';
      return dg;
    },

    getStatusColor(status) {
      if (status === true)  return 'success';
      if (status === false) return 'warning';
      if (!status)          return 'warning';
      const colors = {
        PENDING:   'warning',
        APPROVED:  'success',
        REJECTED:  'error',
        CANCELLED: 'grey',
      };
      return colors[String(status).toUpperCase()] || 'info';
    },

    async fetchSalesRepsFromAPI() {
      try {
        this.salesRepsLoading = true;
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url    = `${BASE_URL}/api/getSalesRepByUserAreaCodes?userId=${userId}`;

        const response = await axios.get(url, {
          headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' },
        });

        if (response.data.success && response.data.data) {
          this.agentListsWithDetails = response.data.data.map(rep => ({
            text:       rep.salesRep_name,
            value:      rep.id,
            registration: rep.userCode,
            id:         rep.id,
            userCode:   rep.userCode,
            email:      rep.email,
            areaCodes:  rep.area_codes,
          })).sort((a, b) => a.text.localeCompare(b.text));

          this.salesRepMap = {};
          response.data.data.forEach(rep => { this.salesRepMap[rep.id] = rep.salesRep_name; });
        } else {
          this.agentListsWithDetails = [];
        }
      } catch (error) {
        console.error('Error fetching sales reps:', error);
        this.agentListsWithDetails = [];
      } finally {
        this.salesRepsLoading = false;
      }
    },

    async fetchDealersFromAPI() {
      try {
        this.dealersLoading = true;
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url    = `${BASE_URL}/api/getDealersByUserAreaCodes?userId=${userId}`;

        const response = await axios.get(url, {
          headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' },
        });

        if (response.data.success && response.data.data) {
          this.dealerListsWithDetails = response.data.data.map(dealer => ({
            text:         dealer.dealer_name,
            value:        dealer.dealer_code,
            registration: dealer.dealer_code,
          })).sort((a, b) => a.text.localeCompare(b.text));
        } else {
          this.dealerListsWithDetails = [];
        }
      } catch (error) {
        console.error('Error fetching dealers:', error);
        this.dealerListsWithDetails = [];
      } finally {
        this.dealersLoading = false;
      }
    },

    async fetchAreasFromAPI() {
      try {
        this.areasLoading = true;
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url    = `${BASE_URL}/api/area/user/${userId}`;

        const response = await axios.get(url, {
          headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' },
        });

        if (response.data.success && response.data.data && Array.isArray(response.data.data)) {
          this.areaLists = response.data.data.map(areaCode => ({
            text: areaCode, value: areaCode, title: areaCode,
          })).sort((a, b) => a.text.localeCompare(b.text));
        } else {
          this.areaLists = [];
        }
      } catch (error) {
        console.error('Error fetching areas:', error);
        this.areaLists = [];
      } finally {
        this.areasLoading = false;
      }
    },

    viewItem(item) {
      const receiptId = item.receipt_id;
      if (receiptId) {
        this._saveFiltersToSession();
        sessionStorage.setItem('return_from_notify', 'true');
        this.$router.push(`/total-collections-view/${receiptId}`);
      } else {
        this.snackbarText  = 'Unable to view: Receipt ID not found';
        this.snackbarColor = 'error';
        this.snackbar      = true;
      }
    },

    async notifyItem(item) {
      if (this.notifyingItems.includes(item.id)) return;
      this.notifyingItems.push(item.id);

      try {
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        const response = await axios.post(
          `${BASE_URL}/api/receipt/${item.id}/notify`,
          { userId: parseInt(userId), notify: true },
          { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
        );

        if (response.data && response.data.success === true) {
          const index = this.notifyCollections.findIndex(c => c.id === item.id);
          if (index !== -1) {
            this.notifyCollections[index].notify      = true;
            this.notifyCollections[index].updated_at  = new Date().toISOString();
            if (!this.notifyCollections[index].notify_approval_details) {
              this.notifyCollections[index].notify_approval_details = {
                notify_approval_status:  'PENDING',
                notify_approved_at:      null,
                notify_approved_comment: null,
                notify_approved_by:      null,
              };
            }
          }

          this.snackbarText  = response.data.message || `Receipt ${item.receipt_id} notified successfully!`;
          this.snackbarColor = 'success';
          this.snackbar      = true;

          EventBus.emit('overdueCollectionNotified', item);
        } else {
          throw new Error(response.data?.message || 'Notify update failed');
        }

      } catch (error) {
        let msg = 'Error updating notify status. ';
        if (error.response) {
          if      (error.response.status === 404) msg += 'API endpoint not found.';
          else if (error.response.status === 401) msg += 'Unauthorized. Please login again.';
          else if (error.response.status === 403) msg += "You don't have permission.";
          else if (error.response.data?.message)  msg += error.response.data.message;
          else                                    msg += 'Server error. Please try again.';
        } else if (error.request) {
          msg += 'No response from server.';
        } else {
          msg += error.message || 'Please try again.';
        }
        this.snackbarText  = msg;
        this.snackbarColor = 'error';
        this.snackbar      = true;
      } finally {
        const idx = this.notifyingItems.indexOf(item.id);
        if (idx !== -1) this.notifyingItems.splice(idx, 1);
      }
    },

    applyFilters() {
      this.currentPage = 1;
      this.fetchNotifyCollections(1);
    },

    buildFilterParams() {
      const params  = {};
      const userId  = localStorage.getItem('userId');
      params.userId = parseInt(userId);

      if (this.selectedAgent && this.selectedAgent.length > 0) params.saleRep_id = this.selectedAgent.join(',');
      if (this.selectedRoute && this.selectedRoute.length > 0) params.route_type = this.selectedRoute.join(',');
      if (this.selectedDealer && this.selectedDealer.length > 0) params.dealer_code = this.selectedDealer.join(',');
      if (this.selectDistrict && this.selectDistrict.length > 0) params.area_code = this.selectDistrict.join(',');
      if (this.selectedStatus && this.selectedStatus.length > 0) params.payment_status = this.selectedStatus.join(',');
      if (this.selectedCollectionType && this.selectedCollectionType.length > 0) params.payment_method = this.selectedCollectionType.join(',');
      if (this.selectedCompany && this.selectedCompany.length > 0) params.ar_company = this.selectedCompany.join(',');
      
      if (this.selectedApprovedStage && this.selectedApprovedStage.length > 0) {
        params.approval_status = this.selectedApprovedStage.join(',');
        params.notify_approval_status = this.selectedApprovedStage.join(',');
      }

      const dateRange = this.getDateRange();
      if (dateRange) {
        params.date_from = dateRange.from;
        params.date_to   = dateRange.to;
      }

      if (this.search && this.search.trim().length > 0) params.search = this.search.trim();

      return params;
    },

    async fetchAllFilteredData() {
      const token      = localStorage.getItem('token');
      const url        = `${BASE_URL}/api/receipt/notify-list`;
      const baseParams = this.buildFilterParams();
      const maxPerPage = 500;

      try {
        let allData    = [];
        let lastPage   = 1;

        const firstResponse = await axios.get(url, {
          params:  { ...baseParams, perPage: maxPerPage, page: 1 },
          headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' },
        });

        if (firstResponse.data.success && firstResponse.data.data) {
          allData  = [...firstResponse.data.data];
          lastPage = firstResponse.data.pagination.last_page;

          if (lastPage > 1) {
            const pagePromises = [];
            for (let page = 2; page <= lastPage; page++) {
              pagePromises.push(
                axios.get(url, {
                  params:  { ...baseParams, perPage: maxPerPage, page },
                  headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' },
                }).then(r => (r.data.success && r.data.data) ? r.data.data : [])
              );
            }
            const results = await Promise.all(pagePromises);
            results.forEach(d => { allData = [...allData, ...d]; });
          }
        }

        return allData;
      } catch (error) {
        console.error('❌ Error fetching all filtered data:', error);
        throw error;
      }
    },

    getFilterSummary() {
      const filters = [];
      if (this.selectedAgent && this.selectedAgent.length > 0) {
        const names = this.selectedAgent.map(id => {
          const a = this.agentListsWithDetails.find(x => x.value === id);
          return a ? a.text : id;
        });
        filters.push(`Sales Rep: ${names.join(', ')}`);
      }
      if (this.selectedRoute          && this.selectedRoute.length > 0)    filters.push(`Route: ${this.selectedRoute.join(', ')}`);
      if (this.selectedDealer         && this.selectedDealer.length > 0) {
        const names = this.selectedDealer.map(code => {
          const d = this.dealerListsWithDetails.find(x => x.value === code);
          return d ? d.text : code;
        });
        filters.push(`Dealer: ${names.join(', ')}`);
      }
      if (this.selectDistrict         && this.selectDistrict.length > 0)   filters.push(`Area: ${this.selectDistrict.join(', ')}`);
      if (this.selectedStatus         && this.selectedStatus.length > 0)   filters.push(`Payment Status: ${this.selectedStatus.join(', ')}`);
      if (this.selectedCollectionType && this.selectedCollectionType.length > 0) filters.push(`Collection Type: ${this.selectedCollectionType.join(', ')}`);
      if (this.selectedCompany        && this.selectedCompany.length > 0)  {
        const names = this.selectedCompany.map(v => this.getShortCompanyName(v));
        filters.push(`Company: ${names.join(', ')}`);
      }
      if (this.selectedApprovedStage  && this.selectedApprovedStage.length > 0) filters.push(`Notify Stage: ${this.selectedApprovedStage.join(', ')}`);
      
      const dateRange = this.getDateRange();
      if (dateRange) {
        if (dateRange.from === dateRange.to) filters.push(`Date: ${dateRange.from}`);
        else filters.push(`Date Range: ${dateRange.from} to ${dateRange.to}`);
      }
      
      if (this.search && this.search.trim()) filters.push(`Search: "${this.search}"`);
      return filters.length > 0 ? filters.join(' | ') : 'No filters applied';
    },

    getChequeDateForInvoice(invoice) {
      if (!invoice) return '-';
      const chequeDate = invoice.cheque_date;
      if (!chequeDate) return '-';
      
      try {
        if (typeof chequeDate === 'string' && chequeDate.trim().startsWith('[')) {
          const parsed = JSON.parse(chequeDate);
          if (Array.isArray(parsed) && parsed.length > 0) return this.formatDateForExcel(parsed[0]);
        }
        if (Array.isArray(chequeDate) && chequeDate.length > 0) return this.formatDateForExcel(chequeDate[0]);
        return this.formatDateForExcel(chequeDate);
      } catch (e) {
        return this.formatDateForExcel(chequeDate);
      }
    },

    getChequeNumberForInvoice(invoice) {
      if (!invoice) return '-';
      const chequeNumber = invoice.cheque_number;
      if (!chequeNumber) return '-';
      
      try {
        if (typeof chequeNumber === 'string' && chequeNumber.trim().startsWith('[')) {
          const parsed = JSON.parse(chequeNumber);
          if (Array.isArray(parsed) && parsed.length > 0) return parsed[0] || '-';
        }
        if (Array.isArray(chequeNumber) && chequeNumber.length > 0) return chequeNumber[0] || '-';
        return chequeNumber || '-';
      } catch (e) {
        return chequeNumber || '-';
      }
    },

    getBankNameForInvoice(invoice) {
      if (!invoice) return '-';
      const bankName = invoice.bank_name;
      if (!bankName) return '-';
      
      try {
        if (typeof bankName === 'string' && bankName.trim().startsWith('[')) {
          const parsed = JSON.parse(bankName);
          if (Array.isArray(parsed) && parsed.length > 0) return parsed[0] || '-';
        }
        if (Array.isArray(bankName) && bankName.length > 0) return bankName[0] || '-';
        return bankName || '-';
      } catch (e) {
        return bankName || '-';
      }
    },

    loadImageAsBase64(imagePath) {
      return new Promise((resolve) => {
        try {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            try {
              resolve(canvas.toDataURL('image/png'));
            } catch (e) {
              console.warn('Canvas toDataURL failed:', e);
              resolve(null);
            }
          };
          img.onerror = () => {
            console.warn('Failed to load image:', imagePath);
            resolve(null);
          };
          img.src = imagePath;
        } catch (e) {
          console.warn('Error loading image:', e);
          resolve(null);
        }
      });
    },

    async exportPDF() {
      this.exporting = true;
      try {
        const allData = await this.fetchAllFilteredData();
        if (!allData || allData.length === 0) { 
          this.exporting = false;
          this.snackbarText = 'No data to export';
          this.snackbarColor = 'warning';
          this.snackbar = true;
          return; 
        }

        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();

        let headerY = 10;

        try {
          const logo1Base64 = await this.loadImageAsBase64(require('@/img/company_logo/logo-dark 2.png'));
          const logo2Base64 = await this.loadImageAsBase64(require('@/img/company_logo/g-sfa.png'));

          if (logo1Base64) doc.addImage(logo1Base64, 'PNG', 14, headerY, 30, 12);
          if (logo2Base64) doc.addImage(logo2Base64, 'PNG', 48, headerY, 30, 12);
        } catch (logoError) {
          console.warn('⚠️ Could not load logos for PDF:', logoError);
        }

        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.text('Notify Collections Report', pageWidth / 2, headerY + 5, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`Generated on: ${new Date().toLocaleString()}`, pageWidth / 2, headerY + 13, { align: 'center' });

        let filterY = headerY + 22;
        doc.setFontSize(8);
        const splitFilterText = doc.splitTextToSize(`Filters applied: ${this.getFilterSummary()}`, pageWidth - 28);
        doc.text(splitFilterText, 14, filterY);
        filterY += (splitFilterText.length * 4) + 4;
        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text(`Total Records: ${allData.length}`, 14, filterY);
        filterY += 8;
        doc.setFont(undefined, 'normal');

        const tableData  = [];
        let rowCounter   = 1;

        allData.forEach(item => {
          const notifyStatus = item.notify_approval_details
            ? item.notify_approval_details.notify_approval_status
            : (item.notify ? 'PENDING' : 'NOT NOTIFIED');

          const salesExCode = this.getSalesExecutiveCode(item) || '-';
          const salesExName = this.getSalesExecutiveName(item) || '-';
          const manualReceiptNo = item.manual_receipt_number || '-';

          const base = {
            receiptId:       item.receipt_id || '-',
            manualReceiptNo: manualReceiptNo,
            date:            this.formatDateForExcel(item.created_at),
            dateTime:        this.formatTimeForExcel(item.created_at),
            notifyDate:      item.notify ? this.formatDateForExcel(item.updated_at || item.created_at) : 'Not Notified',
            notifyTime:      item.notify ? this.formatTimeForExcel(item.updated_at || item.created_at) : '',
            areaCode:        item.area_code    || '-',
            companyName:     this.getShortCompanyName(item.ar_company) || '-',
            salesExCode,
            salesExName,
            customerNo:      item.dealer_code  || '-',
            customerName:    item.dealer_name  || '-',
            customerDisGroup:this.getDiscountGroup(item),
            collectionAmount:item.collect_total_amount || 0,
            paymentMethod:   item.payment_method || '-',
            paymentStatus:   item.payment_status || '-',
            receiptStatus:   item.receipt_status || '-',
            overdueDays:     this.getOverdueDisplayText(item),
            overdueReason:   item.overdue_reason || '-',
            notifyStatus,
          };

          const invoices = (item.items && item.items.length > 0) ? item.items : [null];
          invoices.forEach(invoice => {
            tableData.push([
              rowCounter++,
              base.receiptId,
              base.manualReceiptNo,
              `${base.date} ${base.dateTime}`,
              base.notifyDate && base.notifyTime ? `${base.notifyDate} ${base.notifyTime}` : base.notifyDate,
              base.areaCode,
              base.companyName,
              base.salesExCode,
              base.salesExName,
              base.customerNo,
              base.customerName,
              base.customerDisGroup,
              invoice ? invoice.document_no || '-'                  : '-',
              invoice ? this.formatDateForExcel(invoice.posting_date) : '-',
              invoice ? this.formatNumber(invoice.amount)              : '-',
              this.formatNumber(base.collectionAmount),
              base.paymentMethod,
              base.paymentStatus,
              base.receiptStatus,
              base.overdueDays,
              base.overdueReason,
              invoice ? this.getChequeDateForInvoice(invoice) : '-',
              invoice ? this.getChequeNumberForInvoice(invoice) : '-',
              invoice ? this.getBankNameForInvoice(invoice) : '-',
              base.notifyStatus,
            ]);
          });
        });

        doc.autoTable({
          head: [[
            '#', 'Receipt ID', 'Manual Receipt No', 'Date', 'Notify Date', 'Area Code', 'Company Name',
            'Sales Ex. Code', 'Sales Executive Name', 'Customer No', 'Customer Name',
            'Customer Dis.Group', 'Invoice No', 'Invoice Date', 'Invoice Amount',
            'Collection Amount (LKR)', 'Payment Method', 'Payment Status', 'Receipt Status',
            'Overdue Days', 'Overdue Reason', 'Cheque Date', 'Cheque No', 'Bank Name', 'Notify Status',
          ]],
          body:           tableData,
          startY:         filterY,
          styles:         { fontSize: 5.5, cellPadding: 1 },
          headStyles:     { fillColor: [1, 87, 155], textColor: [255, 255, 255], fontSize: 6, fontStyle: 'bold', halign: 'center' },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          columnStyles: {
            0:  { cellWidth: 6,  halign: 'center' },
            1:  { cellWidth: 16, halign: 'left' },
            2:  { cellWidth: 16, halign: 'left' },
            3:  { cellWidth: 22, halign: 'left' },
            4:  { cellWidth: 20, halign: 'left' },
            5:  { cellWidth: 10, halign: 'center' },
            6:  { cellWidth: 16, halign: 'left' },
            7:  { cellWidth: 13, halign: 'left' },
            8:  { cellWidth: 22, halign: 'left' },
            9:  { cellWidth: 12, halign: 'left' },
            10: { cellWidth: 22, halign: 'left' },
            11: { cellWidth: 14, halign: 'left' },
            12: { cellWidth: 16, halign: 'left' },
            13: { cellWidth: 14, halign: 'left' },
            14: { cellWidth: 16, halign: 'right' },
            15: { cellWidth: 18, halign: 'right' },
            16: { cellWidth: 13, halign: 'left' },
            17: { cellWidth: 12, halign: 'left' },
            18: { cellWidth: 12, halign: 'left' },
            19: { cellWidth: 14, halign: 'left' },
            20: { cellWidth: 20, halign: 'left' },
            21: { cellWidth: 12, halign: 'left' },
            22: { cellWidth: 12, halign: 'left' },
            23: { cellWidth: 16, halign: 'left' },
            24: { cellWidth: 14, halign: 'left' },
          },
          margin:     { left: 6, right: 6, top: 10, bottom: 10 },
          tableWidth: 'auto',
          showHead:   'everyPage',
          pageBreak:  'auto',
        });

        const fileName = `notify_collections_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.pdf`;
        doc.save(fileName);
        this.logDocumentDownload(fileName, 'pdf');

      } catch (error) {
        console.error('❌ Error exporting PDF:', error);
        this.snackbarText  = 'Failed to export PDF: ' + (error.message || 'Unknown error');
        this.snackbarColor = 'error';
        this.snackbar      = true;
      } finally {
        this.exporting = false;
      }
    },

    async exportExcel() {
      this.exporting = true;
      try {
        const allData = await this.fetchAllFilteredData();
        if (!allData || allData.length === 0) { 
          this.exporting = false;
          this.snackbarText = 'No data to export';
          this.snackbarColor = 'warning';
          this.snackbar = true;
          return; 
        }

        const wsData = [[
          '#', 'Receipt ID', 'Manual Receipt No', 'Date', 'Notify Date', 'Area Code', 'Company Name',
          'Sales Ex. Code', 'Sales Executive Name', 'Customer No', 'Customer Name',
          'Customer Dis.Group', 'Invoice No', 'Invoice Date', 'Invoice Amount',
          'Collection Amount (LKR)', 'Payment Method', 'Payment Status', 'Receipt Status',
          'Overdue Days', 'Overdue Reason', 'Cheque Date', 'Cheque No', 'Bank Name', 'Notify Status',
        ]];

        let rowCounter = 1;

        allData.forEach(item => {
          const notifyStatus = item.notify_approval_details
            ? item.notify_approval_details.notify_approval_status
            : (item.notify ? 'PENDING' : 'NOT NOTIFIED');

          const salesExCode = this.getSalesExecutiveCode(item) || '-';
          const salesExName = this.getSalesExecutiveName(item) || '-';
          const manualReceiptNo = item.manual_receipt_number || '-';

          const base = {
            receiptId:        item.receipt_id || '-',
            manualReceiptNo:  manualReceiptNo,
            date:             this.formatDateForExcel(item.created_at),
            dateTime:         this.formatTimeForExcel(item.created_at),
            notifyDate:       item.notify ? this.formatDateForExcel(item.updated_at || item.created_at) : 'Not Notified',
            notifyTime:       item.notify ? this.formatTimeForExcel(item.updated_at || item.created_at) : '',
            areaCode:         item.area_code    || '-',
            companyName:      this.getShortCompanyName(item.ar_company) || '-',
            salesExCode,
            salesExName,
            customerNo:       item.dealer_code  || '-',
            customerName:     item.dealer_name  || '-',
            customerDisGroup: this.getDiscountGroup(item),
            collectionAmount: item.collect_total_amount || 0,
            paymentMethod:    item.payment_method || '-',
            paymentStatus:    item.payment_status || '-',
            receiptStatus:    item.receipt_status || '-',
            overdueDays:      this.getOverdueDisplayText(item),
            overdueReason:    item.overdue_reason || '-',
            notifyStatus,
          };

          const invoices = (item.items && item.items.length > 0) ? item.items : [null];
          invoices.forEach(invoice => {
            wsData.push([
              rowCounter++,
              base.receiptId,
              base.manualReceiptNo,
              `${base.date} ${base.dateTime}`,
              base.notifyDate && base.notifyTime ? `${base.notifyDate} ${base.notifyTime}` : base.notifyDate,
              base.areaCode,
              base.companyName,
              base.salesExCode,
              base.salesExName,
              base.customerNo,
              base.customerName,
              base.customerDisGroup,
              invoice ? invoice.document_no || '-'                  : '-',
              invoice ? this.formatDateForExcel(invoice.posting_date) : '-',
              invoice ? this.formatNumber(invoice.amount)              : '-',
              this.formatNumber(base.collectionAmount),
              base.paymentMethod,
              base.paymentStatus,
              base.receiptStatus,
              base.overdueDays,
              base.overdueReason,
              invoice ? this.getChequeDateForInvoice(invoice) : '-',
              invoice ? this.getChequeNumberForInvoice(invoice) : '-',
              invoice ? this.getBankNameForInvoice(invoice) : '-',
              base.notifyStatus,
            ]);
          });
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        ws['!cols'] = [
          { wch: 6  }, { wch: 18 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
          { wch: 12 }, { wch: 35 }, { wch: 16 }, { wch: 25 }, { wch: 15 },
          { wch: 30 }, { wch: 20 }, { wch: 18 }, { wch: 15 }, { wch: 18 },
          { wch: 22 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
          { wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 15 },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Notify Collections');
        const fileName = `notify_collections_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        XLSX.writeFile(wb, fileName);
        this.logDocumentDownload(fileName, 'excel');

      } catch (error) {
        console.error('❌ Error exporting Excel:', error);
        this.snackbarText  = 'Failed to export Excel: ' + (error.message || 'Unknown error');
        this.snackbarColor = 'error';
        this.snackbar      = true;
      } finally {
        this.exporting = false;
      }
    },

    async fetchNotifyCollections(page = 1) {
      this.loading = true;
      try {
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        if (!token || !userId) throw new Error('Authentication required');

        const params = { userId: parseInt(userId), perPage: this.perPage, page };

        if (this.selectedAgent && this.selectedAgent.length > 0) params.saleRep_id = this.selectedAgent.join(',');
        if (this.selectedRoute && this.selectedRoute.length > 0) params.route_type = this.selectedRoute.join(',');
        if (this.selectedDealer && this.selectedDealer.length > 0) params.dealer_code = this.selectedDealer.join(',');
        if (this.selectDistrict && this.selectDistrict.length > 0) params.area_code = this.selectDistrict.join(',');
        if (this.selectedStatus && this.selectedStatus.length > 0) params.payment_status = this.selectedStatus.join(',');
        if (this.selectedCollectionType && this.selectedCollectionType.length > 0) params.payment_method = this.selectedCollectionType.join(',');
        if (this.selectedCompany && this.selectedCompany.length > 0) params.ar_company = this.selectedCompany.join(',');
        
        if (this.selectedApprovedStage && this.selectedApprovedStage.length > 0) {
          params.approval_status = this.selectedApprovedStage.join(',');
          params.notify_approval_status = this.selectedApprovedStage.join(',');
        }

        const dateRange = this.getDateRange();
        if (dateRange) {
          params.date_from = dateRange.from;
          params.date_to   = dateRange.to;
        }

        if (this.search && this.search.trim().length > 0) params.search = this.search.trim();

        console.log('Fetching with params:', params);

        const response = await axios.get(`${BASE_URL}/api/receipt/notify-list`, {
          params,
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        });

        if (response.data.success) {
          this.notifyCollections = response.data.data;
          if (response.data.pagination) {
            this.paginationInfo = response.data.pagination;
            this.currentPage    = response.data.pagination.current_page;
            this.totalPages     = response.data.pagination.last_page;
          }
        } else {
          throw new Error(response.data.message || 'Failed to fetch data');
        }
      } catch (error) {
        console.error('Error fetching notify collections:', error);
        this.snackbarText  = error.response?.data?.message || 'Error fetching data. Please try again.';
        this.snackbarColor = 'error';
        this.snackbar      = true;
        this.notifyCollections = [];
      } finally {
        this.loading = false;
      }
    },

    async logDocumentDownload(fileName, fileType) {
      try {
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        await axios.post(`${BASE_URL}/api/log-document-download`, {
          user_id:     userId,
          file_type:   fileType,
          file_name:   fileName,
          entity_area: 'Notify Collections List',
        }, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    setupEventListeners() {
      EventBus.on('overdueCollectionRefresh', () => {
        this.fetchNotifyCollections(this.currentPage);
      });
    },

    removeEventListeners() {
      EventBus.off('overdueCollectionRefresh');
    },
  },

  watch: {
    search: {
      handler: _.debounce(function () {
        if (this.skipNextSearchWatch) {
          this.skipNextSearchWatch = false;
          return;
        }
        if (this.isRestoring) return;
        this.applyFilters(); 
        this._saveFiltersToSession();
      }, 500),
    },
    selectedReceiptIds: { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedAgent:      { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedRoute:      { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedDealer:     { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectDistrict:     { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedStatus:     { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedCollectionType: { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedCompany:    { handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedApprovedStage: {
      handler(newVal) {
        if (this.isRestoring) return;
        console.log('Selected Approval Stage changed:', newVal);
        this.applyFilters();
        this._saveFiltersToSession();
      }, 
      deep: true 
    },
    dates: {
      handler() { if (this.isRestoring) return; this.applyFilters(); this._saveFiltersToSession(); },
      deep: true
    },
    panelOpen: {
      handler() { this._saveFiltersToSession(); },
      deep: true,
    },
  },

  mounted() {
    this.permissions = getPermissions(8, 'Collection Notify List');

    if (!this.permissions.read) {
      alert('Access Denied');
      this.$router.push('/dashboard');
    }

    this.isRestoring = true;
    const restored = this._restoreFiltersFromSession();
    this.$nextTick(() => {
      this.isRestoring = false;
    });

    this.setupEventListeners();
    this.fetchSalesRepsFromAPI();
    this.fetchDealersFromAPI();
    this.fetchAreasFromAPI();
    
    const targetPage = restored && this.currentPage ? this.currentPage : 1;
    this.fetchNotifyCollections(targetPage);
  },

  beforeUnmount() {
    this._saveFiltersToSession();
    this.removeEventListeners();
  },
};
</script>

<style>
@import "../../styles/collection_management/collection_management.scss";

.custom_view_btn {
  background-color: rgb(128, 0, 128) !important;
  color: white !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 8px;
  padding: 0 12px;
  height: 28px;
  box-shadow: 0 2px 4px rgba(128, 0, 128, 0.2);
}
.custom_view_btn:hover:not(:disabled) {
  background-color: rgb(100, 0, 100) !important;
  box-shadow: 0 4px 8px rgba(128, 0, 128, 0.3);
}
.custom_view_btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.custom_notify_btn {
  background-color: #0288D1 !important;
  color: white !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 8px;
  padding: 0 12px;
  height: 28px;
  box-shadow: 0 2px 4px rgba(2, 136, 209, 0.2);
}
.custom_notify_btn:hover:not(:disabled) {
  background-color: #01579B !important;
  box-shadow: 0 4px 8px rgba(2, 136, 209, 0.3);
}
.custom_notify_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom_approve_btn {
  background-color: #2E7D32 !important;
  color: white !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 8px;
  padding: 0 12px;
  height: 28px;
  box-shadow: 0 2px 4px rgba(46, 125, 50, 0.25);
}
.custom_approve_btn:hover:not(:disabled) {
  background-color: #1B5E20 !important;
  box-shadow: 0 4px 8px rgba(46, 125, 50, 0.35);
}
.custom_approve_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom_details_btn {
  background-color: #6A1B9A !important;
  color: white !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 8px;
  padding: 0 12px;
  height: 28px;
  box-shadow: 0 2px 4px rgba(106, 27, 154, 0.25);
}
.custom_details_btn:hover:not(:disabled) {
  background-color: #4A148C !important;
  box-shadow: 0 4px 8px rgba(106, 27, 154, 0.35);
}
.custom_details_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom_table_curved .v-data-table__wrapper table {
  border-collapse: separate;
  border-spacing: 0 4px;
}
.custom_table_curved .v-data-table__wrapper table tbody tr {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  margin-bottom: 4px;
}
.custom_table_curved .v-data-table__wrapper table tbody tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.custom_table_curved .v-data-table__wrapper table tbody tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.compact-table .v-data-table__tr {
  height: 28px !important;
}
.compact-table .v-data-table__td {
  padding: 2px 8px !important;
  font-size: 12px !important;
  line-height: 1.2 !important;
}
.compact-table .v-data-table-header__th {
  padding: 4px 8px !important;
  font-size: 11px !important;
  line-height: 1.2 !important;
  height: 32px !important;
}
.compact-table .v-data-table__tr td .v-chip {
  height: 20px !important;
  font-size: 10px !important;
}
.compact-table .v-btn--size-x-small {
  height: 24px !important;
  font-size: 10px !important;
  padding: 0 8px !important;
}
.compact-table .v-icon {
  font-size: 14px !important;
}

.v-row.dense {
  margin-top: -4px !important;
  margin-bottom: -4px !important;
}
.v-row.dense .v-col {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.v-list-item-subtitle {
  font-size: 11px !important;
  line-height: 1.2 !important;
  opacity: 0.9;
  margin-top: 0 !important;
}
.v-list-item__prepend {
  align-self: flex-start !important;
  margin-top: 4px !important;
}

.v-overlay {
  z-index: 1000;
}
.v-data-table tbody tr:hover {
  background-color: #f5f5f5 !important;
  transition: background-color 0.3s ease;
}
.v-chip {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
}
.custom_card_box {
  overflow: hidden;
}

.table-wrapper {
  position: relative;
  overflow: hidden;
}

.v-data-table .v-table__wrapper {
  overflow-y: auto !important;
  overflow-x: auto !important;
}

.v-data-table .v-table__thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}

.v-expansion-panel-text__wrapper {
  padding: 8px 16px !important;
}
</style>